<script lang="ts">
  import Chip from "@components/Chip.svelte";
  import UserMenu from "@components/Core/UserDisplay/UserMenu.svelte";
  import SupportingMenu from "@components/Supporting/SupportingMenu.svelte";
  import { setCtx as setSupportingContext } from "@components/Supporting/context";
  import Can from "./AccessControl/Can.svelte";
  import { Roles } from "@utils/decorators";
  import HelpMenu from "./Core/UserDisplay/HelpMenu.svelte";
  import { authentication } from "@utils/keycloak";

  setSupportingContext();

  const envName: string | undefined = process.env.ENV_NAME;
  const envNameColor = envName?.toLowerCase().includes("production") ? "green" : "orange";
</script>

<div
  class="flex flex-row justify-between px-4 py-2 border border-base-200 justify-items-center"
>
  <div class="flex flex-row gap-4 font-bold">
    <div>KNOWLEDGE GRAPH</div>
    {#if envName}
      <Chip text={envName} variant={envNameColor} />
    {/if}
  </div>

  <div class="flex items-center justify-center gap-4">
    <Can roles={[Roles.DEV, Roles.CONCEPT]}>
      <SupportingMenu />
    </Can>
    <!-- <NotificationsMenu /> -->
    <HelpMenu />
    <UserMenu />
    <div>
      <p class="font-medium leading-5 text-m">
        {$authentication && `${$authentication.profile.username} (${
            $authentication.role === "Dev" ? "Admin" : $authentication.role
        })`}
      </p>
    </div>
  </div>
</div>
